import * as React from "react";
import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import EditIcon from "@mui/icons-material/Edit";
import Divider from "@mui/material/Divider";
import ArchiveIcon from "@mui/icons-material/Archive";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AddIcon from "@mui/icons-material/Add";
import { disableItem } from "../../utils/commonFunction";
import { CloudUpload, CreateNewFolder } from "@mui/icons-material";
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: "rgb(55, 65, 81)",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
        ...theme.applyStyles("dark", {
          color: "inherit",
        }),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
    ...theme.applyStyles("dark", {
      color: theme.palette.grey[300],
    }),
  },
}));

export default function CreteNewButtonComponet(props) {
  const {
    setShowAddFolderDialog,
    setShowAddDrawingDialog,
    isCreatingFolder = false,
    isLoadingDirectories = false,
  } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="contained"
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        size="small"
        sx={{
          minHeight: 36,
          textTransform: "none",
          fontFamily: "Roboto, sans-serif",
          fontSize: "14px",
          fontWeight: 500,
          bgcolor: "#2932E5",
          color: "white",
          borderRadius: "10px !important",
          px: 2,
          "&:hover": {
            bgcolor: "#1f28b8",
          },
          "&:disabled": {
            bgcolor: "#E5E7EB",
            color: "#9CA3AF",
          },
        }}
      >
        New
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        slotProps={{
          list: {
            "aria-labelledby": "demo-customized-button",
          },
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          disableRipple
          onClick={() => {
            handleClose();
            setShowAddFolderDialog(true);
          }}
          disabled={isCreatingFolder || isLoadingDirectories}
        >
          <CreateNewFolder fontSize="small" />
          Create New Folder
        </MenuItem>
        <MenuItem
          disableRipple
          onClick={() => {
            handleClose();
            setShowAddDrawingDialog(true);
          }}
          disabled={isCreatingFolder || isLoadingDirectories}
        >
          <CloudUpload fontSize="small" />
          Create New Drawing
        </MenuItem>
      </StyledMenu>
    </div>
  );
}
